class MemberStore {
  constructor() {
    this.bindActions(this.alt.getActions('Member'));
    this.login = false;
  }

  onLogin() {
    this.login = true;
  }

  onLogout(){
    this.login = false;
  }
}

export default MemberStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Member.js